export const STALE_TIME_30_SECONDS = 30_000;
export const STALE_TIME_1_MINUTE = 60_000;
export const STALE_TIME_5_MINUTES = 300_000;

export const REFETCH_INTERVAL_5_SECONDS = 5_000;
export const REFETCH_INTERVAL_1_MINUTE = 60_000;
export const REFETCH_INTERVAL_5_MINUTES = 300_000;
